<template>
    <div v-if="userInfo">

        <sg-items-block name="Контакты">

            <v-list-item @click="$router.push({ name: 'wv-settings-phone'})">
                <v-list-item-content class="d-block">
                    <v-list-item-title>{{ userInfo.contacts.phone || 'Отсутствует' }}
                    </v-list-item-title>
                    <v-list-item-subtitle>Номер телефона</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            
            <v-divider style="margin-left:16px" />

            <v-list-item @click="$router.push({ name: 'wv-settings-email'})">
                <v-list-item-content class="d-block">
                    <v-list-item-title>{{ userInfo.contacts.email ? userInfo.contacts.email : 'Отсутствует' }}
                    </v-list-item-title>
                    <v-list-item-subtitle>Адрес электронной почты</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

        </sg-items-block>

        <sg-items-block name="Настройки аккаунта">

            <v-list-item @click="$router.push({name: 'wv-settings-notifications', params: { userInfo }})" single-line>


                <v-list-item-icon class="mr-4">
                    <v-icon>mdi-bell-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>
                        Оповещения
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider style="margin-left:56px" />

            <v-list-item @click="$router.push({name: 'wv-settings-receipt', params: { userInfo }})">
                
                <v-list-item-icon class="mr-4">
                    <v-icon>mdi-table</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>
                        Электронная квитанция
                    </v-list-item-title>
                </v-list-item-content>

            </v-list-item>

            <v-divider style="margin-left:56px" />

            <v-list-item @click="$router.push({name: 'wv-settings-cheque', params: { userInfo }})">

                <v-list-item-icon class="mr-4">
                    <v-icon>mdi-receipt</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="align-center">
                        Электронный чек
                    </v-list-item-title>
                </v-list-item-content>

            </v-list-item>

            <v-divider style="margin-left:56px" />

            <v-list-item @click="$router.push({name: 'wv-settings-secure', params: { userInfo }})">

                <v-list-item-icon class="mr-4">
                    <v-icon>mdi-lock-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>
                          Безопасность
                    </v-list-item-title>
                </v-list-item-content>

            </v-list-item>

        </sg-items-block>

        <v-btn v-if="$sg.options.showBack" block tile depressed class="mt-3" @click="saveAndClose">
            Назад{{changed ? '*' : ''}}
        </v-btn>

        <v-footer height="32" app>
            <div class="grey--text">{{APP_VERSION}}</div>
        </v-footer>


    </div>
</template>

<script>

    import pageMixin from '../pageMixin'

    export default {
        mixins: [pageMixin],

        computed: {
            hasPhone() {
                return !!this.userInfo.contacts.phone
            },
            hasEmail() {
                return !!this.userInfo.contacts.email
            },
            userInfo() {
                return this.$store.state.settings.userInfo
            },
            loading() {
                return this.$store.state.settings.loading
            },
            changed() {
                return this.$store.state.settings.changed
            }
        },

        methods: {
            saveAndClose() {
                /* 
                                this.$router.back() */

                if (this.changed) {
                    this.result('settings-ok')
                } else {
                    this.result('cancel')
                }
            },

            onHashChange() {
                if (location.hash == '') {

                    this.saveAndClose()
                }
            }
        },


        created() {
            this.$store.commit('settings/SET_ENTERED', true)
            window.addEventListener('hashchange', this.onHashChange, false);
            location.hash = '#edit'
        },

        beforeDestroy() {
            window.removeEventListener('hashchange', this.onHashChange, false);
        }

    }
</script>

<style>

</style>